import { StrictMode } from 'react';
import { type Container, createRoot } from 'react-dom/client';
import './globals.css';
import './core/config/i18n';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './query/query-client';
import BaseLayout from '@/core/components/BaseLayout';
import App from './app';
import { ErrorBoundary } from '@/core/config/bugsnag';

createRoot(document.getElementById('root') as Container).render(
	<ErrorBoundary>
		<StrictMode>
			<QueryClientProvider client={queryClient}>
				<BaseLayout>
					<App />
				</BaseLayout>
			</QueryClientProvider>
		</StrictMode>
	</ErrorBoundary>,
);
